import React from "react";
import { Redirect, Route } from "react-router-dom";
import { isSignedIn, roleOf } from "../../Util/session";

// AUTH-01. Authorisation used to be three inline ternaries in src/pages/index.jsx —
// `agent && agent.role === "admin" ? <Page/> : <Redirect to="/search" />` — and one
// mount-time effect that decided whether the whole app should bounce to /welcome. There
// was no route guard at all, so a route added later inherited nothing, and the effect ran
// once per mount, never on navigation.
//
// RoleRoute is that decision, per route. It is UI-level only: the role still comes from
// localStorage, which the user controls, so it decides what to SHOW. What is ALLOWED is
// enforced on the server (VT-BE utils/requestIdentity.js).

// A route that needs the admin role. A signed-in non-admin goes to /search, which is what
// the inline ternaries did. A signed-out visitor goes to /welcome — deliberately the same
// destination the app-wide guard in pages/index.jsx uses, so the two cannot disagree about
// where a logged-out visitor lands and race each other to send them to different places.
//
// `?next=` lives on the 401 path instead (Util/authInterceptor.js), which is the case that
// matters: a session that expires mid-visit, where the user was already somewhere.
// `role` is one role or a list of them (AUTH-08: the SHub panel is for admin and tal).
export const RoleRoute = ({ children, role = "admin", fallback = "/search", ...rest }) => (
  <Route
    {...rest}
    render={() => {
      if (!isSignedIn()) return <Redirect to="/welcome" />;
      const roles = Array.isArray(role) ? role : [role];
      const allowed = roles.includes(roleOf());
      return allowed ? children : <Redirect to={fallback} />;
    }}
  />
);

export default RoleRoute;
